/**
 * @generated SignedSource<<2149147ffce3488e5a20116fa85121a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "propertyId"
      }
    ],
    "concreteType": "Property",
    "kind": "LinkedField",
    "name": "property",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 500
          }
        ],
        "concreteType": "MeterConnection",
        "kind": "LinkedField",
        "name": "meters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeterEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Meter",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "identifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tradePointId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "dataBatchingPropertyMetersQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "dataBatchingPropertyMetersQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "16a43ee8e41b997e85342fbe376f9efe",
    "id": null,
    "metadata": {},
    "name": "dataBatchingPropertyMetersQuery",
    "operationKind": "query",
    "text": "query dataBatchingPropertyMetersQuery(\n  $propertyId: ID!\n  $after: String\n) {\n  property(id: $propertyId) {\n    id\n    meters(first: 500, after: $after) {\n      edges {\n        node {\n          id\n          identifier\n          title\n          tradePointId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "4eca102075c3ad45352a457d59dc058d";

module.exports = node;
